import React from 'react'
import * as moment from 'moment'

const Date = ({ value }) => (
  <>{value ? moment(value).utc().format('YYYY-MM-DD') : ''}</>
)

export default Date
